"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapsible = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _useSpacingStyles = require("../hooks/useSpacingStyles");
var _layout = require("../layout");
var _useCollapsibleMotionProps = require("./useCollapsibleMotionProps");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Collapsible = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(({
  children,
  collapsed = true,
  maxHeight,
  maxWidth,
  accessibilityLabelledBy,
  direction = 'vertical',
  testID,
  id,
  role = 'region',
  dangerouslyDisableOverflowHidden = false,
  // Spacing
  spacing,
  spacingBottom,
  spacingEnd,
  spacingHorizontal,
  spacingStart,
  spacingTop,
  spacingVertical
}, forwardedRef) => {
  const styles = (0, _useCollapsibleMotionProps.useCollapsibleMotionProps)({
    collapsed,
    direction,
    dangerouslyDisableOverflowHidden
  });
  const outerSpacing = (0, _useSpacingStyles.useSpacingStyles)({
    spacingTop
  });
  const innerSpacing = (0, _useSpacingStyles.useSpacingStyles)({
    spacing,
    spacingBottom,
    spacingEnd,
    spacingHorizontal,
    spacingStart,
    spacingVertical
  });
  const sizeProps = (0, _react.useMemo)(() => {
    return direction === 'horizontal' ? {
      maxWidth,
      // prevent horizontal scrollbar when animating
      display: 'inline-flex'
    } : {
      maxHeight
    };
  }, [direction, maxWidth, maxHeight]);
  const Stack = direction === 'horizontal' ? _layout.HStack : _layout.Box;
  return /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, _extends({}, styles, {
    ref: forwardedRef,
    "aria-labelledby": accessibilityLabelledBy,
    "data-testid": testID,
    id: id,
    role: role
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: outerSpacing
  }, /*#__PURE__*/_react.default.createElement(Stack, _extends({
    overflow: maxWidth || maxHeight ? 'auto' : undefined
  }, sizeProps, {
    className: innerSpacing
  }), children)));
}));
exports.Collapsible = Collapsible;